<template>
  <!--2021新版机考无简答题-->
<div class="ques-sheet" v-if="questions">
  <ul>
    <li v-for="(item, index) in questions" :key="index" class="firstLi">
      <div class="wrap-group-name" @click="toggle(index)">
        <span class="group-fold"></span>
        <span class="group-name">{{item.viewTypeName}}</span>
      </div>
      <ul class="list" v-if="item.quesTypeID!==4 && item.quesTypeID!==5">
        <li
          v-for="(ele,idx) in item.list"
          :key="idx"
          :class="sign(ele)"
          @click="toggleSmallQues(index,idx,null,null)">&nbsp;
          <span class="num-val">{{ele.showSerialNum}}</span>
        </li>
      </ul>
      <div class="list list1" v-else>
        <span
          class="short"
          v-for="(ele,idx) in item.list"
          :key="idx"
          >
          <span
            v-if="ele.smallContent && ele.smallContent.length > 0"
            v-for="(obj,smallIndex) in ele.smallContent"
            :key="smallIndex"
            class="s1"
            :class="signSmallContent(obj,smallNum)"
            @click="toggleSmallQues(index,idx,smallIndex,obj.newNum)">
            <span class="num-val">{{obj.newNum}}</span>
          </span>
          <span
            v-if="!ele.smallContent"
            class="s1"
            :class="sign(ele)"
            @click="toggleSmallQues(index,idx,null,null)">&nbsp;
            <span class="num-val">{{ele.serialNum}}</span>
          </span>
        </span>
      </div>
    </li>
  </ul>
</div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'ExamQuesList',
    data(){
      return{
        newNum:0,
        SerialNum:0,
      }
    },
    computed: {
      ...mapGetters([
        'questions',
        'currentQuestion'
      ])
    },
    props:{
      smallNum:{
        type:Number
      }
    },
    watch:{
      questions: {
        handler(newVal) {
          this.getNewQuestions()
        }
      }
    },
    mounted(){
      this.getNewQuestions()
    },
    methods: {
      getNewQuestions(){
        if(this.questions.length>0){
          var smallNum = []
          this.questions.forEach((val) =>{
            if(val.quesTypeID===5){
              var num = 0
              var smallNumb = 0
              smallNum.forEach(item=>{
                  smallNumb += item
              })
              val.list.forEach((item,index) =>{
                if(index>0){
                  if (val.list[(index-1)].smallContent && val.list[(index-1)].smallContent.length>0){
                    this.SerialNum = Number(this.SerialNum)+val.list[(index-1)].smallContent.length
                  }
                }else{
                  this.SerialNum = item.showSerialNum
                }
                if (!item.smallContent){
                  num += 1
                }
                if (item.smallContent && item.smallContent.length > 0){
                  smallNum.push(item.smallContent.length - 1)
                  item.smallContent.forEach((obj,idx) =>{
                    obj.newNum = Number(this.SerialNum) +idx + num + smallNumb
                    this.$forceUpdate()
                  })
                }
              })
            }
          })
        }
      },
      toggleSmallQues(quesType, quesIndex,smallIndex,smallId) {
        // debugger;
        if(smallId){
          this.$emit('quesFn', quesType, quesIndex,smallIndex,'#smallId'+smallId,this.currentQuestion)
        }else{
          this.$emit('quesFn', quesType, quesIndex,smallIndex,smallId,this.currentQuestion)
        }

      },
      //答题卡标记字符
      sign(ques) {
        if (
          //当前题 已答
          ques.questionID === this.currentQuestion.questionID &&
          ques.isAnswer === 1 &&
          ques.isMark !== 1
        ) {
          return 'current'
        }else if(
          //当前题 标记
          ques.questionID === this.currentQuestion.questionID &&
          ques.isMark === 1
        ){
          return 'current marked'
        }else if(
          //已答 未标记
          (ques.isMark === 0 || ques.isMark === null) &&
          ques.isAnswer === 1
        ){
          return 'done'
        }else if(ques.isMark === 1 && ques.isAnswer === 1){
          //已答 已标记
          return 'done marked'
        } else if(ques.isMark === 1 && ques.isAnswer !== 1){
          //未答 已标记
          return 'marked'
        } else if (ques.questionID === this.currentQuestion.questionID) {
          // 当前题
          return 'current'
        } else if (ques.isAnswer === 1) {
          // 已答
          return 'done'
        }

      },

      //答题卡标记字符-综合题
      signSmallContent(ques,smallNum) {
        if(
          this.currentQuestion.smallContent &&
          this.currentQuestion.smallContent.length>smallNum &&
          ques.newNum === this.currentQuestion.smallContent[smallNum].newNum &&
          ques.isMark !==1){
          return 'current'
        }else if(
          this.currentQuestion.smallContent &&
          this.currentQuestion.smallContent.length>smallNum &&
          ques.isMark ===1 &&
          ques.newNum === this.currentQuestion.smallContent[smallNum].newNum){
          return 'current marked'
        }else if( ques.isAnswer === 1 && ques.isMark !== 1){
          return 'done'
        }else if( ques.isAnswer !== 1 && ques.isMark === 1){
          return 'marked'
        }else if(ques.isAnswer === 1 && ques.isMark === 1){
          return 'done marked'
        }else{
          return ''
        }
      },
      //切换显隐
      toggle(index) {
        if ($('.ques-sheet').find('.firstLi').eq(index).hasClass('active')) {
          $('.ques-sheet').find('.firstLi').eq(index).removeClass('active')
        } else {
          $('.ques-sheet').find('.firstLi').eq(index).addClass('active')
        }
      }
    }

  }
</script>
<style lang="scss" scoped>
 $imgUrl: '~@/assets/images/doExam/';
 .ques-sheet{
   .active{
     .list{
       display: none;
     }
     .group-fold{
       width: 8px !important;
       height: 14px !important;
       background: url($imgUrl + "icon-right.png") no-repeat !important;
       margin-right: 17px !important;
       position: relative;
       left: 5px;
     }
   }
   .wrap-group-name{
     cursor: pointer;
     .group-fold{
       display: inline-block;
       width:15px;
       height:8px;
       cursor: pointer;
       transition: .3s all;
       background: url($imgUrl + "icon-down.png") no-repeat;
       margin-right: 10px;
     }
     .group-name{
       font-size: 16px;
       font-weight: 700;
       margin: 10px 0;
       color: #666;
     }
   }
   .list{
     margin-top: 8px;
     margin-bottom: 16px;
     overflow: hidden;
     li{
       float: left;
       /*width:28px;*/
       /*margin: 0 5px 8px 5px;*/
       width:20%;
       margin-bottom: 8px;
       height: 28px;
       text-align: center;
       cursor: pointer;
       color: #000;
       .num-val {
         border: 1px solid #999;
         position: relative;
         width: 28px;
         height: 28px;
         font-size: 15px;
         border-radius: 4px;
         text-align: center;
         line-height: 28px;
         display: inline-block;
         overflow: hidden;
       }
       &.current .num-val{
         background-color: #447dff;
         border-color: #447dff;
         color: #fff;
       }
       &.done .num-val{
         background-color: #55db9a;
         border-color: #55db9a;
         color: #fff;
       }
       &.marked .num-val:after {
         content: "";
         position: absolute;
         bottom: 0;
         right: -12px;
         border-width: 0 11px 11px;
         border-style: solid;
         border-color: transparent transparent #ff5464;
       }
     }
   }
   .list1{
     .s1{
       /*width: 28px;*/
       height: 28px;
       display: inline-block;
       /*margin:0 5px 8px 5px;*/
       cursor: pointer;
       width: 20%;
       margin-bottom: 8px;
       .num-val {
         border: 1px solid #999;
         position: relative;
         width: 28px;
         height: 28px;
         font-size: 15px;
         border-radius: 4px;
         text-align: center;
         line-height: 28px;
         display: inline-block;
         overflow: hidden;
       }
       &.current .num-val{
         background-color: #447dff !important;
         border-color: #447dff !important;
         color: #fff;
       }
       &.done .num-val{
         background-color: #55db9a;
         border-color: #55db9a;
         color: #fff;
       }
       &.marked .num-val:after {
         content: "";
         position: absolute;
         bottom: 0;
         right: -12px;
         border-width: 0 11px 11px;
         border-style: solid;
         border-color: transparent transparent #ff5464;
       }

     }
   }
 }
</style>
